export default __webpack_public_path__ + "static/media/2026.10999ad2.png";